export const TAG_TYPES = [
    {value: 'region', label: 'Region', description: 'Administrative or territory-based grouping, e.g. north-uk, central-europe, west-coast'},
    {value: 'group', label: 'Group', description: 'Operational or brand grouping of locations, e.g. flagship-stores, outlet-stores'},
    {value: 'territory', label: 'Territory', description: 'Broad territory or macro-region, e.g. europe, north-america, asia-pacific'},
];

export const TAG_VALUE_PATTERN = /^[^\n]+$/;

export const TAG_VALUE_MAX_LENGTH = 128;

export const formatTag = (tag) =>
    tag && typeof tag === 'object' ?
        `${TAG_TYPES.find(t => t.value === tag.tagType)?.label || tag.tagType}: ${tag.tagValue}`
        : String(tag ?? '');
